import { keyBy } from 'lodash';
import { flow, getEnv, types } from 'mobx-state-tree';

import CampaignCode from '../models/CampaignCode';
import StatefulStore from '../models/StatefulStore';
import RequestState, { RequestStateType } from "../types/RequestState";

const CampaignCodeStore = StatefulStore.named('CampaignCodeStore')
  .props({
    activeCodes: types.optional(types.array(CampaignCode), []),
    setCodeState: types.optional(RequestStateType, RequestState.NONE),
  })
  .actions((self) => {
    return {
      setup: function (activeCodes) {
        self.activeCodes = keyBy(activeCodes, 'id');
        self.setLoading(false);
      },
      loadActiveCodes: flow(function* getActiveCodes() {
        self.setLoading(true);

        try {
          self.activeCodes = yield getEnv(self).apiWrapper.request(
            `campaign-codes`,
            {},
            { active_section: null }
          );
        } catch (error) {
          self.setError(error);
          throw error;
        }

        self.setLoading(false);
      }),
      setCode: flow(function* setCode(campaignCode) {
        self.setCodeState = RequestState.LOADING;
        try {
          yield getEnv(self)
            .apiWrapper.apiAxios()
            .post(`campaign-codes/set`, { campaignCode });

          yield self.loadActiveCodes();
          self.setCodeState = RequestState.LOADED;
        } catch (error) {
          self.setError(error);
          self.setCodeState = RequestState.ERROR;
          throw error;
        }
      }),
      unsetCode: flow(function* unsetCode() {
        self.setLoading(true);

        yield getEnv(self).apiWrapper.apiAxios().post(`campaign-codes/unset`);

        yield self.loadActiveCodes();
        self.setLoading(false);
      }),
    };
  })
  .views((self) => ({
    get activeCoupon() {
      return !!self.activeCodes.length && self.activeCodes[0];
    },
    get campaignCodesArray() {
      return Array.from(self.activeCodes, ([key, value]) => value);
    },
  }));

export default CampaignCodeStore;
